
import React from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { validate, validatorFromFunction, validators, combine } from 'validate-redux-form';
import { renderField, renderTextArea } from '../../../Utils/renderField';
import { Link } from 'react-router-dom';
import { renderAntTimeField } from '../../../Utils/renderField/renderField';


const renderContactos = ({fields, meta: {error, submitFailed }, contactos}) => (
    <div className=" col-sm-12 p-0">
        <div className=" col-sm-12 form-group np-r p-0">
            <div className="react-bs-container-header table-header-wrapper">
                <table className="table table-striped table-highlight  mb-0">
                    <thead>
                    <tr>
                        <th></th>
                        <th>NOMBRE</th>
                        <th>PUESTO</th>
                        <th>TELÉFONO</th>
                        <th>E-MAIL</th>
                    </tr>
                    </thead>
                {/* </table>

            </div>
           
            <div className="contenido-contactos">
                <table className="table table-sm  m-0 table-striped"> */}
                    <tbody>
                    {fields.map((contacto, index) => (
                        <tr key={index}>
                            <td className="text-center sin-borde-top" style={{width: "48px"}}>
                                <img className="action-img" src={require('assets/img/icons/Cerrar.png')} alt="Borrar"
                                     title="Borrar" 
                                     onClick={() =>{
                                         fields.remove(index)
                                     }}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.nombre`}
                                    type="text"
                                    component={renderField}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.puesto`}
                                    type="puesto"
                                    component={renderField}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.telefono`}
                                    type="telefono"
                                    component={renderField}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.correo`}
                                    type="correo"
                                    component={renderField}
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-start mt-2">
                <button type="button" className="btn btn-primary py-0" onClick={() => fields.push({})}>
                    AGREGAR CONTACTO
                </button>
            </div>
        </div>
    </div>
)


const ContactoForm = (props) => {
    const { handleSubmit, previousStep } = props;
    return (
        <form name="ContactoForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
            <div className="row justify-content-center">
                <h4 className="t-primary" >CONTACTOS</h4>
            </div>
            <FieldArray name="contactos" component={renderContactos} />
            <div className="row  justify-content-sm-around justify-content-center">
                <button onClick={previousStep} className="btn btn-secondary m-1 align-self-center">ANTERIOR</button>                        
                <button type="submit" className="btn btn-primary m-1 align-self-center">SIGUIENTE</button>
            </div>
        </form>
    );
};


export default reduxForm({
    form: 'ClientesForm', // a unique identifier for this form
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate: (data) => {
        return validate(data, {
            nombre: validators.exists()('Este campo es requerido'),
            nit: validators.exists()('Este campo es requerido'),
            direccion: validators.exists()('Este campo es requerido'),
        });
    },
})(ContactoForm);
